import { render, staticRenderFns } from "./calculation_options.vue?vue&type=template&id=5c1241d4&"
import script from "./calculation_options.vue?vue&type=script&lang=js&"
export * from "./calculation_options.vue?vue&type=script&lang=js&"
import style0 from "./calculation_options.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1241d4')) {
      api.createRecord('5c1241d4', component.options)
    } else {
      api.reload('5c1241d4', component.options)
    }
    module.hot.accept("./calculation_options.vue?vue&type=template&id=5c1241d4&", function () {
      api.rerender('5c1241d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/calculation_options.vue"
export default component.exports